import { findSelectedOptionLabel, stringifyReferenceDataValue } from './utils'
import { MileageData } from '@cinch-nx/data-search'

export const getFormattedMileage = (
  mileageSelection = -1,
  mileageData: MileageData[],
) => {
  if (mileageSelection === -1) return ''
  return findSelectedOptionLabel(
    stringifyReferenceDataValue(mileageData),
    mileageSelection.toString(),
  )
}
